define((require) => {
    "use strict";

    var ImprovedModel = require("shared/zbone/ImprovedModel"),
        RestApi       = require("shared/services/RestApi"),
        TextUtil      = require("shared/util/TextUtil"),
        Syncer        = require("shared/services/sync/Syncer");

    /**
     * Represents a share of an entity from one user to one or more users. <p>
     *
     * Pure editor model.
     *
     * @author Bruce Mackenzie Nielsen
     * @class Share
     * @constructor
     */
    return ImprovedModel.extend("Share", {

        defaults: {
            to: [],
            message: "",
            link: ""
        },

        constructor: function() {
            this.__super();

            Syncer.State.init(this, {
                alias: {
                    save: "share"
                },
                permissions: {} // no permissions required for sharing!
            });
        },

        url: function() {
            if (this.isNew()) {
                return RestApi.pathToCollection(RestApi.Collections.SHARES);
            }
            return RestApi.pathToSpecificResource(RestApi.Collections.SHARES, this.get("id"));
        },

        _distinguishedName: function() {
            return TextUtil.firstLine(this.get("message"), true); // true = quote the name
        },

        /**
         * Adds a recipient to the share.
         *
         * @param {User} user The user to add as a recipient.
         */
        addRecipient: function(user) {
            this.get("to").push({id: user.get("id")});
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/share/Share.js